<template>
  <div class="main-container">
    <div class="games-meta-data">
      <div class="games-meta-data__left">
        <main-menu></main-menu>
      </div>
      <div class="games-meta-data__right">
        <v-card flat tile>
          <v-select
            outlined
            hide-selected
            persistent-hint
            dense
            auto-select-first
            v-model="selectedFile"
            :items="files"
            return-object
            label="Select a file"
            v-on:change="changeSelectedFile"
          />
          <v-btn :disabled="selectedFile === null" block color="primary" v-on:click="saveData()">Save ALL data</v-btn>
        </v-card>
        <v-card flat tile v-if="selectedFile">
          <v-form>
            <v-jsf v-model=model
                   :schema="schema"
                   :options="options"
            />
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '../../MainMenu/MainMenu.vue';
import data from './ark_category_seo';
import config from '../../../config';

export default {
    name: 'CategoriesSEO',
    components: { MainMenu },
    data() {
        return {
            schema: data,
            model: {},
            files: null,
            selectedFile: null,
            options: {
                filesAsDataUrl: false
            }
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        loadFileContent: async function() {
            let url = `${config.apiUrl}/arc_seo/get?fileName=${this.selectedFile}`;
            await this.$http.get(url).then(
                (response) => {
                    if (response.body) {
                        this.model = JSON.parse(response.body);
                    } else {
                        this.model = {};
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        changeSelectedFile: async function() {
            if (this.selectedFile === null) {
                this.model = {};
            }
            await this.loadFileContent();
        },
        loadData: async function() {
            let url = `${config.apiUrl}/arc_seo/files`;
            await this.$http.get(url).then(
                (response) => {
                    if (response.body) {
                        this.files = response.body;
                    } else {
                        this.files = [];
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        saveData: function() {
            let url = `${config.apiUrl}/arc_seo/save`;
            let formModel = {
                fileName: this.selectedFile,
                data: this.model
            };
            this.$http.post(url, formModel).then(
                async (response) => {
                    await this.loadFileContent();
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }
};
</script>

<style scoped>
.games-meta-data {
    display: flex;

    &__left {
        flex: 0 0 auto;
        width: auto;
    }

    &__right {
        flex: 1;
        min-width: 0;
        width: auto;
    }
}

.column-control__left--games-meta {
    width: 20%;
}

.column-control__right--games-meta {
    width: 80%;
}

.column-control__wrap--games-meta {
    min-height: 669px;
}
</style>
